export interface InseminationAdviceDto {
  cowId: string;
  registrationNumber: string;
  earNumber?: string;
  name?: string;
  ageInMonths: number;
  heightCm?: number;
  estimatedHeightCm?: number;
  dateOfLastInsemination?: string;
  status: InseminationAdviceStatus;
  predictedInseminationDate?: string;
}

export enum InseminationAdviceStatus {
  InseminateAsap = 'InseminateAsap',
  Inseminate = 'Inseminate',
  InseminateInXDays = 'InseminateInXDays',
  AlreadyInseminated = 'AlreadyInseminated',
}

export interface InseminationPrintRow {
  number: string;
  earNumber?: string | null;
  name?: string | null;
  ageInMonths: number;
  hipHeight?: number | null;
  estimatedHipHeight?: number | null;
  lastInsemination: Date | null;
  advice: string;
  status: InseminationAdviceStatus;
  className: string;
}

const STATUS_ORDER: Record<InseminationAdviceStatus, number> = {
  [InseminationAdviceStatus.InseminateAsap]: 0,
  [InseminationAdviceStatus.Inseminate]: 0,
  [InseminationAdviceStatus.InseminateInXDays]: 1,
  [InseminationAdviceStatus.AlreadyInseminated]: 2,
};

export function sortInseminationAdvice(data: InseminationAdviceDto[]): InseminationAdviceDto[] {
  const sorted = [...data];

  sorted.sort((a, b) => {
    const statusDiff = STATUS_ORDER[a.status] - STATUS_ORDER[b.status];
    if (statusDiff !== 0) return statusDiff;

    switch (a.status) {
      case InseminationAdviceStatus.InseminateAsap:
      case InseminationAdviceStatus.Inseminate:
        return b.ageInMonths - a.ageInMonths;

      case InseminationAdviceStatus.InseminateInXDays: {
        const dateA = a.predictedInseminationDate
          ? new Date(a.predictedInseminationDate).getTime()
          : Number.MAX_VALUE;
        const dateB = b.predictedInseminationDate
          ? new Date(b.predictedInseminationDate).getTime()
          : Number.MAX_VALUE;
        return dateA - dateB;
      }

      case InseminationAdviceStatus.AlreadyInseminated: {
        const dateA = a.dateOfLastInsemination ? new Date(a.dateOfLastInsemination).getTime() : 0;
        const dateB = b.dateOfLastInsemination ? new Date(b.dateOfLastInsemination).getTime() : 0;
        return dateB - dateA;
      }

      default:
        return 0;
    }
  });

  return sorted;
}
